import React, { FC } from "react";

import { LoadingSpinner, OnboardingAside, OnboardingContent } from "@xapp/components";

export interface LoadingStepProps {
    /**
     * Optional style applied to the root div
     */
    style?: React.CSSProperties;
    /**
     * Optional class name to apply to the root div
     */
    className?: string;
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;
    /**
     * Optional loading message
     */
    loadingMessage?: string;
    /**
     * Optional error message
     */
    errorMessage?: string;
}

export const LoadingStep: FC<LoadingStepProps> = (props) => {
    const { aside, loadingMessage, errorMessage } = props;

    return (
        <>
            {aside && !errorMessage && <OnboardingAside>{aside}</OnboardingAside>}
            {errorMessage && <OnboardingAside>{errorMessage}</OnboardingAside>}
            <OnboardingContent>
                <LoadingSpinner loadingText={loadingMessage} />
            </OnboardingContent>
        </>
    );
};
